export default {
  props: {
    parentItem: {
      type: Object,
      default: () => {}
    },
    theme: String,
    iconSize: Number
  },
  computed: {
    parentName () {
      return this.parentItem[this.$config.router.urlKey]
    },
    children () {
      return this.parentItem[this.$config.router.childrenKey]
    },
    textColor () {
      return this.theme === 'dark' ? '#fff' : '#495060'
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/main/components/side-menu/item-mixin.js